/** @jsxImportSource @emotion/react */
import useResponsive from "../../../../../hooks/useResponsive";

export default function Year2025() {
  const { isMobile } = useResponsive();
  return (
    <div css={yearStyle}>
      <div css={textBox(isMobile)}>
        <p css={numberText(isMobile)}>12</p>
        <div css={Texts}>
          <p css={text(isMobile)}>데이터 바우처, 수요기업 웨스텍 글로벌 데이터 산업 진흥원 원장상 수상</p>
          <p css={text(isMobile)}>CAPTOS 디지털의료기기인증 2등급획득(D 제인 25-4061호)</p>
        </div>
      </div>
      <div css={textBox(isMobile)}>
        <p css={numberText(isMobile)}>11</p>
        <div css={Texts}>
          <p css={text(isMobile)}>의료기기 ISO 인증 13485 인증</p>
          <p css={text(isMobile)}>2025 대한민국 인공지능 챔피언 대회 TOP 8 수상</p>
        </div>
      </div>
      <div css={textBox(isMobile)}>
        <p css={numberText(isMobile)}>10</p>
        <p css={text(isMobile)}>카자흐스탄 CENTRAL ASIAN GASTROENTEROLOGY WEEK 학회 참여</p>
      </div>
      <div css={textBox(isMobile)}>
        <p css={numberText(isMobile)}>09</p>
        <div css={Texts}>
          <p css={text(isMobile)}>유라, WIMPLE COUNT 제품의 생산 지원 및 해외시장 공동개척을 위한 MOU 업무협약</p>
          <p css={text(isMobile)}>의료 AI데이터 활용 플랫폼 구축 사업(디지털 스크리닝 키트 개발을 위한 생성형 AI기반 소아청소년 만성 염증성 장질환 진단 예측 알고리즘 개발)</p>
        </div>
      </div>
      <div css={textBox(isMobile)}>
        <p css={numberText(isMobile)}>08</p>
        <p css={text(isMobile)}>2025 공공판로 개척 지원 사업(부산 자원순환 클러스터를 지원하는 AIoT 스마트 Bin)</p>
      </div>
      <div css={textBox(isMobile)}>
        <p css={numberText(isMobile)}>06</p>
        <div css={Texts}>
          <p css={text(isMobile)}>중소벤처기업부, 소셜벤처기업 인증</p>
          <p css={text(isMobile)}>2025 커텍티드 의료산업 생태계 활성 촉진 사업(해외 의료진 대상 교육훈련)</p>
          <p css={text(isMobile)}>데이터 바우처 지원사업(폐플라스틱 선별 공정 고도화를 통한 고품질 재생 블록 생산을 위한 데이터 수집 및 가공)</p>
        </div>
      </div>
      <div css={textBox(isMobile)}>
        <p css={numberText(isMobile)}>05</p>
        <div css={Texts}>
          <p css={text(isMobile)}>핀란드 ESPGHAN2025 학회참여 CAPTOS 제품 소개 및 AI 진단 기술 시연</p>
          <p css={text(isMobile)}>UN ITU, AI for good AI 활용 사례집 등재 선정</p>
          <p css={text(isMobile)}>WIMPLE COUNT 캐나다 시장 납품 진행</p>
          <p css={text(isMobile)}>AI 바우처 지원사업 (일반분과) 참여 (재활용 플라스틱 성분별 분류를 위한 비전 AI와 고감도 적외선 스펙트럼 센서 통합 솔루션 개발)</p>
          <p css={text(isMobile)}>AI 바우처 지원사업 (글로벌분과) 참여 (소화기 질환 환자의 정확하고 효율적인 진단을 위한 캡슐내시경 AI 솔루션 해외 진출)</p>
        </div>
      </div>
      <div css={textBox(isMobile)}>
        <p css={numberText(isMobile)}>04</p>
        <div css={Texts}>
          <p css={text(isMobile)}>인간 지향적 차세대 도전형 AI 기술 개발(휴먼 AI 동반자 시대를 위한 AGI:신뢰성,윤리성,적응성을 갖춘 차세대 범용 인공지능 개발)</p>
          <p css={text(isMobile)}>부산시와 시설공단과의 시범사업(파일럿) 진행</p>
          <p css={text(isMobile)}>한국수자원공사 테스트베드 사업 확정 및 도입</p>
          <p css={text(isMobile)}>2025 에코 스타트업 지원 사업 (AI 기반 초고속 재활용 폐기물 계수기 개발 및 해외 실증)</p>
        </div>
      </div>
      <div css={textBox(isMobile)}>
        <p css={numberText(isMobile)}>02</p>
        <div css={Texts}>
          <p css={text(isMobile)}>카자흐스탄 Interna clinic MOU 업무협약</p>
          <p css={text(isMobile)}>스트라티오코리아-서르-웨스텍글로벌 MOU 업무협약</p>
          <p css={text(isMobile)}>신세계프라퍼티와의 PoC 계약 체결,협업 준비</p>
        </div>
      </div>
      <div css={textBox(isMobile)}>
        <p css={numberText(isMobile)}>01</p>
        <div css={Texts}>
          <p css={text(isMobile)}>CES 전시 참여 캡슐내시경 진단보조시스템 홍보</p>
          <p css={text(isMobile)}>초격차 스타트업 1000+ 프로젝트 (인공지능 기반의 캡슐 내시경 판독 보조 시스템)</p>
          <p css={text(isMobile)}>양산 부산대 병원 바이오 Core Facility 구축 사업(염증성 장질환 진단 및 추적 관찰을 위한 AI기반 대장 내시경 병변 탐지,중증도 분석 소프트웨어 개발)</p>
        </div>
      </div>
    </div>
  );
}

const yearStyle = {
  display: "flex",
  flexDirection: "column" as const,
  gap: "10px",
};

const textBox = (isMobile: boolean) => ({
  display: "flex",
  flexDirection: "row" as const,
  gap: isMobile ? "15px" : "30px",
});

const Texts = {
  display: "flex",
  flexDirection: "column" as const,
  gap: "10px",
};

const numberText = (isMobile: boolean) => ({
  fontSize: isMobile ? "14px" : "20px",
  fontWeight: 700,
  lineHeight: "27px",
  textAlign: "center" as const,
  color: "white",
});

const text = (isMobile: boolean) => ({
  fontSize: isMobile ? "14px" : "18px",
  fontWeight: 400,
  lineHeight: "27px",
  textAlign: "left" as const,
  color: "white",
});

const colorText = (isMobile: boolean) => ({
  ...text(isMobile),
  background: "linear-gradient(90deg, #6DDCFF 0%, #7F60F9 100%)",
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
});
